// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fl-pages .clearance-form{margin-bottom:2rem}\n", ""]);
// Exports
module.exports = exports;
